<template>
  <div class="has-text-centered">
    <i class="fa fa-4x fa-spinner fa-pulse"></i>
  </div>
</template>

<script>
export default {}
</script>
